// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Verdana', sans-serif;
  color: #d3dfec;
  background:
    radial-gradient(circle at 8% 8%, rgba(34, 211, 238, 0.2), transparent 28%),
    radial-gradient(circle at 92% 12%, rgba(56, 189, 248, 0.16), transparent 30%),
    linear-gradient(180deg, #111827, #0a111a 70%);
}

#root {
  min-height: 100vh;
}

.app-shell {
  background: transparent;
}

.app-topbar {
  border: 0.5px solid #2b4058;
  border-radius: 14px;
  padding: 14px 16px;
  background: linear-gradient(140deg, #152131, #102030);
  margin: 20px auto 0;
  width: min(1280px, 96vw);
}

.app-topbar .container {
  padding-left: 6px;
  padding-right: 6px;
}

.topbar-btn {
  border: 0.5px solid #285268 !important;
  border-radius: 10px !important;
  background: linear-gradient(180deg, #1a3a4b, #13303f) !important;
  color: #d3dfec !important;
  padding: 8px 12px !important;
  font-size: 0.92rem !important;
}

.topbar-btn:hover,
.topbar-btn:focus,
.topbar-btn:active {
  border-color: #4ca6cf !important;
  background: #133042 !important;
  color: #e3ecf6 !important;
}

.panel-header {
  border: 0.5px solid #2b4058;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 14px;
  background: linear-gradient(180deg, rgba(24, 36, 51, 0.95), rgba(17, 27, 40, 0.95));
}

.panel-header h1 {
  margin: 0;
  font-size: 1.2rem;
}

.panel-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.loading-shell {
  min-height: 70vh;
}

.loading-message {
  color: #d3dfec;
}

.error-banner {
  border: 1px solid #7f1d1d;
  background: rgba(127, 29, 29, 0.24);
  color: #fecaca;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 12px;
}

.workstation-card {
  background: linear-gradient(180deg, rgba(24, 36, 51, 0.95), rgba(17, 27, 40, 0.95)) !important;
  color: #d3dfec !important;
  border-color: #2b4058;
}

.workstation-card .card-header {
  background: rgba(31, 47, 66, 0.62);
  color: #d3dfec;
  border-bottom: 1px solid #2b4058;
}

.workstation-card .card-body,
.workstation-card .card-title,
.workstation-card .card-text {
  color: #d3dfec;
}

.App {
  text-align: center;
  background-color: transparent;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}



@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.action-btn {
  font-weight: 600;
  border-width: 1px;
}

.action-btn:disabled,
.action-btn.disabled {
  font-weight: 500;
  border-width: 0.5px;
  opacity: 0.6;
}

.btn-start-hover:hover,
.btn-start-hover:focus,
.btn-start-hover:active {
  background-color: #a8e6a3 !important;
  border-color: #a8e6a3 !important;
  color: #111 !important;
}

.btn-stop-hover:hover,
.btn-stop-hover:focus,
.btn-stop-hover:active {
  background-color: #f4a7a7 !important;
  border-color: #f4a7a7 !important;
  color: #111 !important;
}

.btn-reboot-hover:hover,
.btn-reboot-hover:focus,
.btn-reboot-hover:active {
  background-color: #f6df8b !important;
  border-color: #f6df8b !important;
  color: #111 !important;
}

.btn-users-hover:hover,
.btn-users-hover:focus,
.btn-users-hover:active {
  background-color: #a7d8f4 !important;
  border-color: #a7d8f4 !important;
  color: #111 !important;
}

.card-header-with-copy {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
}

.card-header-title {
  flex: 1 1 auto;
  min-width: 0;
}

.copy-card-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  margin-left: auto;
}

.copy-card-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  border: 0;
  background: transparent;
  color: #c9d9eb;
  font-size: 1rem;
  line-height: 1;
  padding: 0.15rem 0.25rem;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.15s ease;
}

.copy-card-btn:hover,
.copy-card-btn:focus-visible {
  color: #dfeaf5;
  background-color: rgba(148, 163, 184, 0.22);
  outline: none;
}

.copy-card-btn:active {
  transform: scale(0.96);
}

.copy-card-btn-success {
  background-color: transparent;
}

.copy-card-btn-success:hover,
.copy-card-btn-success:focus-visible {
  background-color: transparent;
}

.copy-card-note {
  color: #c3d6ea;
  font-size: 0.8rem;
  white-space: nowrap;
}

.copy-card-icon {
  display: block;
  width: 1.14rem;
  height: 1.14rem;
  fill: currentColor;
  transform: translate(0.03rem, -0.02rem);
}

.copy-card-icon-check {
  width: 1.02rem;
  height: 1.02rem;
  transform: none;
}

.instance-spec-divider {
  margin: 0.55rem 0 0.65rem;
  border-top: 1px solid rgba(148, 163, 184, 0.28);
}

.instance-spec-table-wrap {
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 0.55rem;
  background: rgba(31, 47, 66, 0.55);
  padding: 0.35rem 0.55rem;
  margin-bottom: 0.75rem;
}

.instance-spec-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
  line-height: 1.25;
}

.instance-spec-table th,
.instance-spec-table td {
  padding: 0.22rem 0;
  vertical-align: top;
}

.instance-spec-table th {
  width: 38%;
  font-size: 0.74rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #9cb2ca;
  font-weight: 700;
}

.instance-spec-table td {
  width: 62%;
  color: #d3dfec;
  font-weight: 500;
  text-align: right;
}

.instance-users-panel {
  margin-top: 0.85rem;
  border: 1px solid rgba(148, 163, 184, 0.24);
  border-radius: 0.55rem;
  background: rgba(12, 20, 32, 0.5);
  padding: 0.65rem;
}

.instance-users-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.45rem;
  color: #d3dfec;
}

.instance-users-header strong {
  font-size: 0.86rem;
}

.instance-users-header span {
  color: #9cb2ca;
  font-size: 0.74rem;
  white-space: nowrap;
}

.instance-users-empty,
.instance-users-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.45rem;
  padding: 0.5rem 0.6rem;
  font-size: 0.82rem;
}

.instance-users-empty {
  color: #b8cbe0;
  background: rgba(31, 47, 66, 0.48);
}

.instance-users-error {
  color: #fecaca;
  background: rgba(127, 29, 29, 0.24);
}

.instance-users-table-wrap {
  overflow-x: auto;
}

.instance-users-table {
  width: 100%;
  min-width: 520px;
  border-collapse: collapse;
  font-size: 0.78rem;
  line-height: 1.25;
}

.instance-users-table th,
.instance-users-table td {
  padding: 0.3rem 0.35rem;
  border-top: 1px solid rgba(148, 163, 184, 0.16);
  vertical-align: top;
}

.instance-users-table th {
  color: #9cb2ca;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
}

.instance-users-table td {
  color: #d3dfec;
}

.draggable-instance-card {
  cursor: grab;
}

.draggable-instance-card.dragging {
  opacity: 0.65;
  transform: scale(0.99);
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,cAAc;EACd;;;iDAG+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,gEAAgE;EAChE,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,gCAAgC;EAChC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,8FAA8F;EAC9F,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,gCAAgC;AAClC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;;AAIA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;;EAEE,cAAc;EACd,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,kCAAkC;EAClC,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Verdana', sans-serif;\n  color: #d3dfec;\n  background:\n    radial-gradient(circle at 8% 8%, rgba(34, 211, 238, 0.2), transparent 28%),\n    radial-gradient(circle at 92% 12%, rgba(56, 189, 248, 0.16), transparent 30%),\n    linear-gradient(180deg, #111827, #0a111a 70%);\n}\n\n#root {\n  min-height: 100vh;\n}\n\n.app-shell {\n  background: transparent;\n}\n\n.app-topbar {\n  border: 0.5px solid #2b4058;\n  border-radius: 14px;\n  padding: 14px 16px;\n  background: linear-gradient(140deg, #152131, #102030);\n  margin: 20px auto 0;\n  width: min(1280px, 96vw);\n}\n\n.app-topbar .container {\n  padding-left: 6px;\n  padding-right: 6px;\n}\n\n.topbar-btn {\n  border: 0.5px solid #285268 !important;\n  border-radius: 10px !important;\n  background: linear-gradient(180deg, #1a3a4b, #13303f) !important;\n  color: #d3dfec !important;\n  padding: 8px 12px !important;\n  font-size: 0.92rem !important;\n}\n\n.topbar-btn:hover,\n.topbar-btn:focus,\n.topbar-btn:active {\n  border-color: #4ca6cf !important;\n  background: #133042 !important;\n  color: #e3ecf6 !important;\n}\n\n.panel-header {\n  border: 0.5px solid #2b4058;\n  border-radius: 14px;\n  padding: 14px;\n  margin-bottom: 14px;\n  background: linear-gradient(180deg, rgba(24, 36, 51, 0.95), rgba(17, 27, 40, 0.95));\n}\n\n.panel-header h1 {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.panel-header-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.loading-shell {\n  min-height: 70vh;\n}\n\n.loading-message {\n  color: #d3dfec;\n}\n\n.error-banner {\n  border: 1px solid #7f1d1d;\n  background: rgba(127, 29, 29, 0.24);\n  color: #fecaca;\n  border-radius: 10px;\n  padding: 10px;\n  margin-bottom: 12px;\n}\n\n.workstation-card {\n  background: linear-gradient(180deg, rgba(24, 36, 51, 0.95), rgba(17, 27, 40, 0.95)) !important;\n  color: #d3dfec !important;\n  border-color: #2b4058;\n}\n\n.workstation-card .card-header {\n  background: rgba(31, 47, 66, 0.62);\n  color: #d3dfec;\n  border-bottom: 1px solid #2b4058;\n}\n\n.workstation-card .card-body,\n.workstation-card .card-title,\n.workstation-card .card-text {\n  color: #d3dfec;\n}\n\n.App {\n  text-align: center;\n  background-color: transparent;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.action-btn {\n  font-weight: 600;\n  border-width: 1px;\n}\n\n.action-btn:disabled,\n.action-btn.disabled {\n  font-weight: 500;\n  border-width: 0.5px;\n  opacity: 0.6;\n}\n\n.btn-start-hover:hover,\n.btn-start-hover:focus,\n.btn-start-hover:active {\n  background-color: #a8e6a3 !important;\n  border-color: #a8e6a3 !important;\n  color: #111 !important;\n}\n\n.btn-stop-hover:hover,\n.btn-stop-hover:focus,\n.btn-stop-hover:active {\n  background-color: #f4a7a7 !important;\n  border-color: #f4a7a7 !important;\n  color: #111 !important;\n}\n\n.btn-reboot-hover:hover,\n.btn-reboot-hover:focus,\n.btn-reboot-hover:active {\n  background-color: #f6df8b !important;\n  border-color: #f6df8b !important;\n  color: #111 !important;\n}\n\n.btn-users-hover:hover,\n.btn-users-hover:focus,\n.btn-users-hover:active {\n  background-color: #a7d8f4 !important;\n  border-color: #a7d8f4 !important;\n  color: #111 !important;\n}\n\n.card-header-with-copy {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n}\n\n.card-header-title {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.copy-card-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.copy-card-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.9rem;\n  height: 1.9rem;\n  border-radius: 50%;\n  border: 0;\n  background: transparent;\n  color: #c9d9eb;\n  font-size: 1rem;\n  line-height: 1;\n  padding: 0.15rem 0.25rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease, transform 0.15s ease;\n}\n\n.copy-card-btn:hover,\n.copy-card-btn:focus-visible {\n  color: #dfeaf5;\n  background-color: rgba(148, 163, 184, 0.22);\n  outline: none;\n}\n\n.copy-card-btn:active {\n  transform: scale(0.96);\n}\n\n.copy-card-btn-success {\n  background-color: transparent;\n}\n\n.copy-card-btn-success:hover,\n.copy-card-btn-success:focus-visible {\n  background-color: transparent;\n}\n\n.copy-card-note {\n  color: #c3d6ea;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n\n.copy-card-icon {\n  display: block;\n  width: 1.14rem;\n  height: 1.14rem;\n  fill: currentColor;\n  transform: translate(0.03rem, -0.02rem);\n}\n\n.copy-card-icon-check {\n  width: 1.02rem;\n  height: 1.02rem;\n  transform: none;\n}\n\n.instance-spec-divider {\n  margin: 0.55rem 0 0.65rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.28);\n}\n\n.instance-spec-table-wrap {\n  border: 1px solid rgba(148, 163, 184, 0.22);\n  border-radius: 0.55rem;\n  background: rgba(31, 47, 66, 0.55);\n  padding: 0.35rem 0.55rem;\n  margin-bottom: 0.75rem;\n}\n\n.instance-spec-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.84rem;\n  line-height: 1.25;\n}\n\n.instance-spec-table th,\n.instance-spec-table td {\n  padding: 0.22rem 0;\n  vertical-align: top;\n}\n\n.instance-spec-table th {\n  width: 38%;\n  font-size: 0.74rem;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #9cb2ca;\n  font-weight: 700;\n}\n\n.instance-spec-table td {\n  width: 62%;\n  color: #d3dfec;\n  font-weight: 500;\n  text-align: right;\n}\n\n.instance-users-panel {\n  margin-top: 0.85rem;\n  border: 1px solid rgba(148, 163, 184, 0.24);\n  border-radius: 0.55rem;\n  background: rgba(12, 20, 32, 0.5);\n  padding: 0.65rem;\n}\n\n.instance-users-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.45rem;\n  color: #d3dfec;\n}\n\n.instance-users-header strong {\n  font-size: 0.86rem;\n}\n\n.instance-users-header span {\n  color: #9cb2ca;\n  font-size: 0.74rem;\n  white-space: nowrap;\n}\n\n.instance-users-empty,\n.instance-users-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  border-radius: 0.45rem;\n  padding: 0.5rem 0.6rem;\n  font-size: 0.82rem;\n}\n\n.instance-users-empty {\n  color: #b8cbe0;\n  background: rgba(31, 47, 66, 0.48);\n}\n\n.instance-users-error {\n  color: #fecaca;\n  background: rgba(127, 29, 29, 0.24);\n}\n\n.instance-users-table-wrap {\n  overflow-x: auto;\n}\n\n.instance-users-table {\n  width: 100%;\n  min-width: 520px;\n  border-collapse: collapse;\n  font-size: 0.78rem;\n  line-height: 1.25;\n}\n\n.instance-users-table th,\n.instance-users-table td {\n  padding: 0.3rem 0.35rem;\n  border-top: 1px solid rgba(148, 163, 184, 0.16);\n  vertical-align: top;\n}\n\n.instance-users-table th {\n  color: #9cb2ca;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.instance-users-table td {\n  color: #d3dfec;\n}\n\n.draggable-instance-card {\n  cursor: grab;\n}\n\n.draggable-instance-card.dragging {\n  opacity: 0.65;\n  transform: scale(0.99);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
